import * as API from '@/services/dataStatistics';

export default {
  namespace: 'dataStatistics',
  state: {
    schoolList: [],
  },
  effects: {
    *statPage({ payload }: any, { call }: any): any {
      const res = yield call(API.statPage, payload);
      return {
        data: res.data || [],
        success: true,
      };
    },

    *statExport({ payload }: any, { call }: any): any {
      return yield call(API.statExport, payload);
    },

    *getSchoolList({ payload }: any, { call, put }: any): any {
      const res = yield call(API.getSchoolList, payload);
      yield put({
        type: '_setState',
        payload: {
          schoolList: res.data || [],
        },
      });
      return res;
    },
  },
  reducers: {
    _setState(state: any, { payload }: any) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
